// @ts-nocheck
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RegistrationPage from '../../components/layouts/RegistrationPage';
import PrimarySubmit from '../../components/button/PrimarySubmit';
import Button from '../../components/button/Button';
import uploadImage from '../../assets/images/upload.png';
import '../emailVerification/Email.scss';

export default function ReadyImage() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const goToCongratulations = () => {
        navigate('/congratulation');
    };

    const goToUpload = () => {
        navigate('/upload');
    };

    return (
        <RegistrationPage
            showBack
            footer={
                <div className='mx-auto flex w-full max-w-md min-[450px]:max-w-none flex-col gap-3 md:mt-8'>
                    <Button
                        type='button'
                        onClick={goToUpload}
                        className='w-full rounded-[14px] !py-3.5 !text-[0.9375rem] !font-bold md:!w-auto md:!min-w-[12.5rem] md:!rounded-xl'
                    >
                        {t('ready.retake')}
                    </Button>
                    <PrimarySubmit onClick={goToCongratulations}>{t('ready.confirm')}</PrimarySubmit>
                </div>
            }
        >
            <div className='email-verify-form mx-auto w-full max-w-md min-[450px]:max-w-none text-center'>
                <img
                    src={uploadImage}
                    alt=''
                    className='mx-auto mb-4 block h-32 w-auto object-contain min-[450px]:mb-[40px]'
                />

                <h2 className='terms-panel__headline mb-3 text-center md:mb-4'>{t('ready.title')}</h2>
                <p className='terms-panel__lead mb-6 text-center'>{t('ready.subtitle')}</p>
            </div>
        </RegistrationPage>
    );
}
